export const topConversationOutcomesDummyData = {
  data: [
    {
      name: 'SESSION_OUTCOME_FAQ_ASSISTANCE_COMPLETE',
      aggValue: '95',
      values: [],
    },
    {
      name: 'SESSION_OUTCOME_BOOKING_COMPLETION',
      aggValue: '48',
      values: [],
    },
    {
      name: 'SESSION_OUTCOME_CANCELLATION_COMPLETION',
      aggValue: '35',
      values: [],
    },
  ],
  aggregates: {
    staffAnswered: '0',
    staffUnanswered: '0',
    followupTasksScheduling: '0',
    followupTasksOthers: '0',
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: '0',
    totalAiThreads: '0',
  },
  summary: [],
};
